import { dayOutParam, parseDayOut, type DayOut } from "./day-out";
import { dayOutPlace, dayOutSportLabel } from "./day-out";
import { removeDownload, saveDownload } from "@/lib/offline/downloads";

export const SAVED_DAY_OUT_KEY = "peakwave:saved-session-window:v1";
const CHANGED = "peakwave-session-window-saved";

export function savedDayOutSnapshot(): string | null {
  try { return typeof window === "undefined" ? null : window.localStorage.getItem(SAVED_DAY_OUT_KEY); }
  catch { return null; }
}

export function subscribeSavedDayOut(callback: () => void) {
  window.addEventListener("storage", callback);
  window.addEventListener(CHANGED, callback);
  return () => { window.removeEventListener("storage", callback); window.removeEventListener(CHANGED, callback); };
}

/** One bounded coastal window. Mountain routes keep their existing store. */
export function saveDayOut(selection: DayOut): boolean {
  const value = dayOutParam(selection);
  if (!value || selection.journeyId || ["ski", "piste", "off-piste", "touring", "mtb"].includes(selection.sport)) return false;
  try {
    window.localStorage.setItem(SAVED_DAY_OUT_KEY, value);
    window.dispatchEvent(new Event(CHANGED));
    return true;
  } catch { return false; }
}

export function removeSavedDayOut(): boolean {
  try { window.localStorage.removeItem(SAVED_DAY_OUT_KEY); window.dispatchEvent(new Event(CHANGED)); return true; }
  catch { return false; }
}

export function readSavedDayOut(raw = savedDayOutSnapshot()): DayOut | null { return parseDayOut(raw); }

/** A separate explicit download keeps the existing saved selection synchronous. */
export async function downloadSavedDayOut(selection: DayOut): Promise<void> {
  const clean = parseDayOut(dayOutParam(selection));
  if (!clean || clean.journeyId) throw new Error("Choose a coastal window first.");
  await saveDownload("window:coastal", "window", (dayOutPlace(clean)?.name ?? clean.slug) + " · " + dayOutSportLabel(clean.sport), clean, new Date().toISOString());
}

export async function removeDownloadedDayOut(): Promise<void> { await removeDownload("window:coastal"); }
